export var INSURANCES_DEFAULT_LIMIT = 20;
export var INSURANCES_CATALOG_LIMIT = 1000;
export var INSURANCES_LOADING_TEXT = "Cargando productos...";
export var INSURANCES_DELETING_TEXT = "Eliminando producto";
export var INSURANCES_DELETE_SUCCESS = "Producto eliminado con éxito.";
export var INSURANCES_DELETE_ENTITY_PROJECT = "ProjectEntity";
export var INSURANCES_DELETE_ENTITY_CAMPAIGN = "CampaignEntity";
export var INSURANCES_ROUTE_CREATE = "/product-creation";
export var insurancesRouteDetail = function (id) { return "/product-creation/".concat(id); };
export var insurancesRouteEdit = function (id) {
    return "/product-creation/".concat(id, "/true");
};
export var insurancesRoutePlans = function (id) {
    return "/product-creation/".concat(id, "/true/true");
};
export var MENU_OPTION_PLANS = "Planes";
export var MENU_OPTION_EDIT = "Modificar";
export var MENU_OPTION_DELETE = "Eliminar";
export var MODAL_DELETE_TITLE = "Eliminar";
export var MODAL_DELETE_QUESTION = "¿Está seguro que desea eliminar";
export var MODAL_DELETE_CANCEL_LABEL = "No";
export var MODAL_DELETE_CONFIRM_LABEL = "Si, eliminar";
